export default function SustainabilityLandingSkeleton() {
  return (
    <div className="min-h-screen bg-black">
      <div className="h-[clamp(560px,88vh,900px)] animate-pulse bg-neutral-900" />
      <div className="container mx-auto px-4 sm:px-8">
        <div className="h-40 max-w-[1200px] rounded bg-neutral-800" />
        <div className="mt-6 h-16 max-w-[800px] rounded bg-neutral-800/80" />
      </div>
      <div className="container mx-auto grid gap-6 px-4 sm:px-8 md:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <div key={i} className="h-80 rounded-2xl bg-neutral-800 animate-pulse" />
        ))}
      </div>
    </div>
  );
}
